// Modal de re-verificación de Cloudflare Turnstile. Se abre cuando el widget
// invisible falla (error/expirado/bloqueado): muestra el mensaje de error y un
// widget VISIBLE para que el usuario reintente la verificación. En cuanto el
// widget visible produce un token (check verde), se llama a onToken y el modal
// se cierra automáticamente desde el hook que lo controla.
//
// Estilos con tokens del design system (bg-card, text, border): se adapta al
// tema claro/oscuro y a los skins OS de manera automática.
import { AlertTriangle, ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import TurnstileWidget from "@/components/turnstile/TurnstileWidget";

export default function TurnstileVerifyModal({ open, onClose, onToken, action }) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
      <DialogContent className="bg-card text-card-foreground border-ink-border max-w-md p-6">
        <DialogHeader className="space-y-2">
          <DialogTitle className="flex items-center gap-2 font-display text-left text-base font-bold text-ink-text">
            <AlertTriangle className="w-4 h-4 text-warning shrink-0" />
            Problemas encontrados
          </DialogTitle>
          <DialogDescription className="text-left text-sm text-ink-muted">
            Verificación anti-bot fallida. Inténtalo de nuevo.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 flex flex-col items-center gap-3">
          <div className="flex items-center gap-1.5 text-[0.7rem] text-ink-muted">
            <ShieldCheck className="w-3.5 h-3.5 text-cyan" />
            <span>Confirma que eres humano para continuar.</span>
          </div>
          {/* Widget visible: el tema (claro/oscuro) se detecta solo en TurnstileWidget. */}
          <TurnstileWidget
            action={action}
            size="normal"
            onToken={(t) => { if (t && t.length > 10) onToken?.(t); }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}